/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  RankedTester,
  rankWith,
  RendererProps,
  UISchemaElement,
  uiTypeIs,
} from "@jsonforms/core";
import React from "react";
import lodash, { get } from "lodash";
import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";

import { useSelector } from "react-redux";
import PaginationWrapper from "../advancedRenderer/dataTableRenderer/PaginationWrapper";

// Lodash

// Redux
import {
  substituteVariables,
  evaluateContextRule,
  extractPath,
} from "../utils/commonUtils";

export const repeaterRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("Repeater")
);

function RepeaterRendererCore(props: any) {
  return <JsonFormsDispatch
    {...props}
    data={{}}
    uischema={{ ...props.uischema, elements: props.data }}
  />
}

function RepeaterRenderer({ uischema, path, schema, visible }: RendererProps) {
  const { renderers, cells } = useJsonForms();
  let updatedContentSchema: any = [];

  const data = uischema.options?.data;
  const contentSchema = uischema.options?.uischema;
  const styleProps = uischema.options?.style || {};
  const spectrumStyle = uischema.options?.spectrumProps || {};

  const layout = uischema.options?.layout;
  const addOnElements = uischema.options?.addOnElements || [];
  const source = data?.source;

  const {
    pagination,
    paginationProps
  } = uischema?.options as any;

  let layOutlabel;

  let values = [];

  if (source === "static") {
    values = data?.values;
  } else if (source === "context") {
    const context = data?.context;
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, context)
    );
    values = reduxState || [];
  }

  updatedContentSchema = values.map((value: any) => {
    const schemaTemplate = lodash.cloneDeep(contentSchema);
    return substituteVariables(schemaTemplate, value);
  });

  if (addOnElements) {
    updatedContentSchema.push(...addOnElements);
  }

  switch (layout?.toLowerCase()) {
    case "horizontal":
      layOutlabel = "HorizontalLayout";
      break;
    case "flex":
      layOutlabel = "Flex";
      break;
    case "vertical":
      layOutlabel = "VerticalLayout";
      break;
    default:
      break;
  }

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <div
      hidden={!componentVisibility}
    >
      <PaginationWrapper
        dataComponent={RepeaterRendererCore}
        dataComponentProps={
          {
            renderers,
            cells,
            uischema:
              {
                type: layOutlabel,
                elements: updatedContentSchema,
                options: {
                  style: styleProps,
                  spectrumProps: spectrumStyle,
                },
              } as UISchemaElement,
            schema,
            path
          }
        }
        pagination={pagination}
        paginationProps={{
          ...paginationProps,
        } || {
          paginationRowsPerPageOptions: [10, 20, 30, 40, 50],
          paginationPerPage: paginationProps?.paginationPerPage?.[0] || 1
        }}
        data={updatedContentSchema}
      />
    </div>
  );
}

export default withJsonFormsLayoutProps(RepeaterRenderer);
